<div class="sc-box" [ngClass]="{'sc-box_error': type=='error'}">
    <ng-container [ngSwitch]="type">
        <sc-icon *ngSwitchCase="'info'" class="sc-box__icon" icon="alert-elipse-copy"></sc-icon>
        <sc-icon *ngSwitchCase="'error'" class="sc-box__icon sc-box__icon_error" icon="close-elipse"></sc-icon>
    </ng-container>
    <div class="sc-box__text" [innerHtml]="content"></div>
</div>
